import React from "react"
import DepartmentHeader from "../components/DepartmentHeader"
import {RoundelGrid} from "../components/RoundelGrid"
import {useTheme} from "@irati/ui/src/global/useTheme"
import {useDepartmentCategoriesQuery} from "@irati/payrollpay/hooks"
import Spinner from "@irati/ui/src/Loading/Spinner"
import {transformToRoundels} from "../utils/roundels"
import {useStoreContext} from "../context/StoreContext"

const DepartmentScreen = () => {
  const theme = useTheme()
  const {schemeType} = useStoreContext()
  const path = window.location.pathname.split("/")
  const departmentId = path[path.length - 1]

  const scheme = {
    organisationId: "566-zz-nhs-demo",
    locale: "en-GB",
    schemeType,
    departmentId: departmentId || ""
  }

  const {data, loading} = useDepartmentCategoriesQuery(scheme, {
    fetchPolicy: "cache-and-network"
  })

  if (loading) {
    return <Spinner />
  }

  const categories = transformToRoundels((data as any)?.employeeOrganisation?.scheme?.department?.categories)

  return (
    <>
      <DepartmentHeader heading={(data as any)?.employeeOrganisation?.scheme?.department?.name ?? "Department"} />

      <RoundelGrid roundels={categories} roundelBackgroundColor={theme.colors.greys.grey03} />
    </>
  )
}

export default DepartmentScreen
